
    import { Component, Vue, Prop } from "vue-property-decorator";

    @Component({
    })
    export default class AlertPopUp extends Vue {

        @Prop()
        msgValue: any;

        onCancelClick() { this.$emit('cancelled'); }
    }

